import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, HomeIcon, ZapIcon } from 'lucide-react';
const sectionVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.25, 0.46, 0.45, 0.94],
      staggerChildren: 0.1
    }
  }
};
const childVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function ProductReveal() {
  return <section className="w-full px-5 py-20 md:py-28" style={{
    backgroundColor: 'var(--color-blush)'
  }} data-id="element-176">
      <motion.div className="max-w-[720px] mx-auto" initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-80px'
    }} variants={sectionVariants} data-id="element-177">
        <motion.p variants={childVariants} className="text-sm md:text-base font-semibold uppercase tracking-widest mb-4" style={{
        color: 'var(--color-sage)'
      }} data-id="element-178">
          Presentando
        </motion.p>

        <motion.h2 variants={childVariants} className="text-3xl md:text-4xl mb-6" style={{
        color: 'var(--color-slate)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-179">
          Mamá 10-Minutos:{' '}
          <span style={{
          color: 'var(--color-tan)'
        }} data-id="element-180">
            Cuerpo Firme Sin Gym
          </span>
        </motion.h2>

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-8" style={{
        color: 'var(--color-slate)',
        opacity: 0.85
      }} data-id="element-181">
          Un sistema de 21 días, en PDF, hecho para mamás que:
        </motion.p>

        <motion.ul variants={childVariants} className="space-y-3 mb-10 pl-1" data-id="element-182">
          <li className="flex items-start gap-3 text-base md:text-lg" style={{
          color: 'var(--color-slate)'
        }} data-id="element-183">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
            backgroundColor: 'var(--color-tan)'
          }} data-id="element-184" />
            no tienen tiempo
          </li>
          <li className="flex items-start gap-3 text-base md:text-lg" style={{
          color: 'var(--color-slate)'
        }} data-id="element-185">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
            backgroundColor: 'var(--color-tan)'
          }} data-id="element-186" />
            tienen interrupciones
          </li>
          <li className="flex items-start gap-3 text-base md:text-lg" style={{
          color: 'var(--color-slate)'
        }} data-id="element-187">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
            backgroundColor: 'var(--color-tan)'
          }} data-id="element-188" />
            están cansadas
          </li>
          <li className="flex items-start gap-3 text-base md:text-lg" style={{
          color: 'var(--color-slate)'
        }} data-id="element-189">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
            backgroundColor: 'var(--color-tan)'
          }} data-id="element-190" />
            y aún así quieren volver a sentirse bien en su cuerpo
          </li>
        </motion.ul>

        {/* What you'll do */}
        <motion.div variants={childVariants} className="rounded-2xl p-8 md:p-10" style={{
        backgroundColor: 'var(--color-white)'
      }} data-id="element-191">
          <h3 className="text-2xl md:text-3xl mb-6" style={{
          color: 'var(--color-slate)',
          fontFamily: "'DM Serif Display', serif"
        }} data-id="element-192">
            Lo que vas a hacer
          </h3>

          <div className="space-y-6" data-id="element-193">
            <div className="flex items-start gap-4" data-id="element-194">
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
              backgroundColor: 'var(--color-sage)',
              opacity: 0.2
            }} data-id="element-195">
                <ClockIcon className="w-5 h-5" style={{
                color: 'var(--color-sage)'
              }} data-id="element-196" />
              </div>
              <div data-id="element-197">
                <p className="text-lg md:text-xl font-semibold mb-1" style={{
                color: 'var(--color-slate)'
              }} data-id="element-198">
                  10 minutos al día.
                </p>
                <p className="text-base md:text-lg leading-relaxed" style={{
                color: 'var(--color-slate)',
                opacity: 0.7
              }} data-id="element-199">
                  En casa. Sin equipo. Sin gym.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-200">
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
              backgroundColor: 'var(--color-sage)',
              opacity: 0.2
            }} data-id="element-201">
                <ZapIcon className="w-5 h-5" style={{
                color: 'var(--color-sage)'
              }} data-id="element-202" />
              </div>
              <div data-id="element-203">
                <p className="text-base md:text-lg leading-relaxed" style={{
                color: 'var(--color-slate)',
                opacity: 0.85
              }} data-id="element-204">
                  Y cuando <strong data-id="element-205">NO</strong> puedas 10 minutos (porque hay
                  días así), no abandonas:
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-206">
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
              backgroundColor: 'var(--color-tan)',
              opacity: 0.2
            }} data-id="element-207">
                <HomeIcon className="w-5 h-5" style={{
                color: 'var(--color-tan)'
              }} data-id="element-208" />
              </div>
              <div data-id="element-209">
                <p className="text-lg md:text-xl font-semibold" style={{
                color: 'var(--color-slate)'
              }} data-id="element-210">
                  Tienes un plan breve de 2–4 minutos para seguir dentro del
                  sistema.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </section>;
}